export function updateFilterDataById(baseArr, data, filterId) {
  for(let idx in baseArr) {
    // When we found the correct filter - Update data
    if(baseArr[idx].filterType === 'filter' && baseArr[idx].id === filterId) {
      baseArr[idx] = {
        ...baseArr[idx],
        selectedData: data
      }
      return baseArr
    }
    // Search through other filters
    else {
      baseArr[idx].filters = updateFilterDataById(baseArr[idx].filters, data, filterId)
    }
  }

  return baseArr
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/updateFilterDataById.js